import React from 'react'

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>

      <h2>What Information Does This Site Collect?</h2>

      <h3>Newsletter or Blog:</h3>
      <p>
        If you voluntarily sign up for M.J. Lindemann’s newsletter or blog, this
        site will record your email address. You can refuse to supply personal
        information, but that will exclude you from certain related activities
        such as receiving newsletters, blogs, and free offers. When subscribers
        click on a link in one of my emails or fills out a form, the site may
        record this information (see below how this information is used).
      </p>
      <p>
        Subscribers may unsubscribe at any time. You may ask for all your data
        to be deleted at any time.
      </p>

      <h3>Giveaways and Contests:</h3>
      <p>
        If you enter a giveaway, your email is collected. If you win a physical
        prize, you will be asked to give your name and physical address.
      </p>

      <h3>Non-personal Information:</h3>
      <p>
        This website may collect non-personal information about visitors when
        they interact with the site. This information may include the browser
        name, means of connection to the site, and other non-identifying
        information.
      </p>

      <h3>Cookies:</h3>
      <p>
        This website may use “cookies” to enhance visitor experience. Typically,
        cookies may be placed on visitors’ hard drive for record-keeping
        purposes and sometimes to track information about them. Visitors may
        choose to set their web browser to refuse cookies, or to alert when
        cookies are being sent. If they do so, note that some parts of the site
        may not function properly.
      </p>

      <h2>How Is the Information Used?</h2>
      <p>
        Newsletter and blog subscribers’ names and emails will only be used for
        receiving the newsletters, the blog, or communication from M.J.
        Lindemann.
      </p>

      <h2>Sharing of Personal Information:</h2>
      <p>
        Subscriber information is never shared with a third party. The only
        exception is that email addresses may occasionally be used to create
        lookalike audiences for online marketing. This in no way distributes the
        emails or signs subscribers up to any other services.
      </p>

      <h2>Third-party links:</h2>
      <p>
        Sometimes M.J. Lindemann may include third-party links through email or
        on the website. These sites have their own policies and you should read
        those before subscribing or purchasing from them.
      </p>

      <h2>Security of Information:</h2>
      <p>
        All information is saved by MailerLite and only M.J. Lindemann and
        MailerLite can access them. Should a data breach ever occur, subscribers
        will be notified within 7 days.
      </p>

      <h2>Use of the Website by Minors:</h2>
      <p>
        All subscribers must be 18 years of age or older or have the consent of
        a parent or guardian.
      </p>

      <h2>Changes to This Privacy Policy:</h2>
      <p>
        M.J. Lindemann may update this privacy policy at any time. A notice
        about such changes will be posted on the website or emailed to M.J.
        Lindemann’s current mailing list. You acknowledge and agree that it is
        your responsibility to review this Privacy Policy periodically and
        become aware of modifications.
      </p>

      <h2>Your Acceptance of These Terms:</h2>
      <p>
        By visiting and using mjlindemann.com, you signify your acceptance of
        this Privacy Policy. If you do not agree, you can simply not use the
        site. Continued use of the site means you accept the policy and any
        periodic changes.
      </p>

      <h2>Questions?</h2>
      <p>
        If you have any questions about this Privacy Policy or anything else on
        mjlindemann.com, please email M.J. Lindemann at
        mjlindemann@mjlindemann.com.
      </p>
    </div>
  )
}

export default PrivacyPolicy
